import React from "react";
import { IconButton } from "@mui/material";
import TextInputField from "../../../../components/form-fields/text-input-field/text-input-field";
import DateRangePickerField from "../../../../components/form-fields/date-range-picker/date-range-picker";
import SelectField from "../../../../components/form-fields/select-field/select-field";
import DummyField from "../../../../components/dummy-field/dummy-field";
import {
  ClockWithPlusIcon,
  DollarIcon,
  Delete,
} from "../../../../utils/svg-components";
import { COLOUR_CONSTANT } from "../../../../utils/contants";
import { formatNumber } from "../../../../utils/utils";

const TaskHeader = ({
  isGeneralUser,
  task,
  milestoneIndex,
  taskIndex,
  handleDelete,
  handleTaskChange,
  handleDateRangeChange,
  defaultDateRange,
  onChangeResponsibility,
  newBuilderTaskHours,
  newBuilderTaskCost,
}) => {
  return (
    <div className="grid-task" onClick={(e) => e.stopPropagation()}>
      <div className="name-duration-task">
        <div className="name">
          {!isGeneralUser && (
            <IconButton onClick={() => handleDelete(taskIndex)}>
              <Delete />
            </IconButton>
          )}
          <TextInputField
            isRequired
            value={task?.description}
            label="Task Description"
            disabled={isGeneralUser}
            onChange={(e) =>
              handleTaskChange(
                milestoneIndex,
                taskIndex,
                "description",
                e.target.value
              )
            }
          />
        </div>

        <DateRangePickerField
          label="Duration (mm-dd-yyyy)"
          name={task?.description}
          defaultValue={defaultDateRange}
          disabled={isGeneralUser}
          onChange={(e) => handleDateRangeChange(e, milestoneIndex, taskIndex)}
        />
        <SelectField
          label="Responsibility*"
          required
          value={task.organization}
          placeholder="Select"
          disabled={isGeneralUser}
          options={[
            { label: "FKA", value: "FKA" },
            { label: "Client", value: "Client" },
          ]}
          onChange={(e) =>
            onChangeResponsibility(
              taskIndex,
              e,
              newBuilderTaskHours,
              newBuilderTaskCost
            )
          }
        />
      </div>
      <div className="dummyField">
        <DummyField
          label="Hours"
          value={formatNumber(task?.hours ?? 0)}
          startIcon={<ClockWithPlusIcon />}
          background={COLOUR_CONSTANT.theme.purple.light}
        />
        <DummyField
          label="Value"
          value={formatNumber(task?.budget ?? 0)}
          startIcon={<DollarIcon />}
          background={COLOUR_CONSTANT.theme.purple.light}
        />
      </div>
    </div>
  );
};

export default TaskHeader;
